import { createContext, ReactNode, useEffect, useState } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { theme } from './theme';

interface ThemeState {
  theme: string | null;
  updateTheme: (theme: string | null) => void;
  removeTheme: () => void;
}

const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'light',
      updateTheme: (value) => set({ theme: value }),
      removeTheme: () => set({ theme: null }),
    }),
    {
      name: 'theme-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

type ThemeContextType = {
  isDarkMode: boolean;
  isMobile: boolean | null;
  toggleMobile: (set?: any) => void;
  toggleTheme: (set?: any) => void;
  ts: any;
  theme: {
    COLORS: {
      textw: string;
      background: string;
      gray: string;
      grey: string;
      bgColor: string;
      descBox: string;
      drawerBgColor: string;
      opacityBgColor: string;
      textsilver: string;
      textGrey: string;
      textGray: string;
      borderColor: string;
      header: string;
      subHeader: string;
      shadow: string;
      cardOpacity: string;
      mdrawerBgColor: string;
      tradeBG: string;
      content: string;
      stroke: string;
      Secondary: string;
      Tertiary: string;
      onSecondary: string;
      onTertiary: string;
      Prinary: string;
      complementary: string;
      point: string;
      fail: string;
      raise: string;
      fail_sub: string;
      raise_sub: string;
      descBorder: string;
      tabMenuActive: string;
      tabMenuInactive: string;
      tabMenuMobileBorder: string;
      descText: string;
      listIconBorder: string;
      listIconBackground: string;
      itemTitle: string;
      itemContent: string;
      itemSubTitle: string;
      itemBg: string;
      tableBg: string;
      searchText: string;
      tableBtn: string;
      sectionDesc: string;
      positiveItem: string;
      memuHover: string;
      subMenuHover: string;
      numberText: string;
      gridBorder: string;
      transactionTableBorder: string;
      mobileTradeBorder: string;

      //FossX
      ButtonBg: string;
      ButtonBorder: string;
      PrimaryBg: string;
      PrimaryBorder: string;
      SocialButtonBg: string;
      GrayDesText: string;
      SecondaryBorder: string;
      MobileSecondaryBorder: string;
      BoxBg: string;
      SubmenuBorder: string;
      SubmenuBg: string;
      DropdownBg: string;
      DropdownHoverBg: string;
      PrimaryInputBg: string;
      PrimaryInputBorder: string;
      PrimaryTableBg: string;
      PrimaryTableBorder: string;
      CardBorder: string;
      CardBg: string;
      SecondaryCardBg: string;
      greenText: string;
    };
  };
};
type ThemeProviderProps = {
  children: ReactNode;
};
export const ThemeContext = createContext<ThemeContextType>(
  {} as ThemeContextType
);

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  // const [ts, setTs] = useRecoilState(themeState);

  const ts = useThemeStore((state) => state.theme);
  const setTs = useThemeStore((state) => state.updateTheme);

  const isDarkMode = ts === 'dark';

  console.log('THEME', ts);
  console.log('IS DARK MODE', isDarkMode);

  const [themeCheck, setThemeCheck] = useState<any>(
    isDarkMode ? theme.dark : theme.light
  );

  const [isMobile, setIsMobile] = useState<any>(null);

  const toggleMobile = (set) => {
    setIsMobile(set !== undefined ? set : isMobile ? false : true);
  };

  const toggleTheme = (set) => {
    console.log('TOGGLE THEME=======', set);
    const newTheme = set !== undefined ? set : ts === 'light' ? 'dark' : 'light';

    // View Transition API 지원 확인
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        setTs(newTheme);
      });
    } else {
      // 폴백: 일반 CSS transition 사용
      setTs(newTheme);
    }
  };

  useEffect(() => {
    setThemeCheck(ts == 'dark' ? theme.dark : theme.light);
  }, [ts]);

  return (
    <ThemeContext.Provider
      value={{
        isDarkMode: isDarkMode,
        isMobile,
        toggleMobile,
        toggleTheme,
        theme: ts == 'dark' ? theme.dark : theme.light,
        ts,
      }}
    >
      <StyledThemeProvider theme={themeCheck}>{children}</StyledThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
